export const getDeleteFlowNodeById = (deleteNode, nodes) => {
  const { nodeId } = deleteNode;
  const newNodes = nodes.filter(n => n.id !== nodeId);

  return [...newNodes];
};
